
import Event = createjs.Event;

export class Poker2TournamentDataEvent extends Event {
    public static CHANGE_TOURNAMENT_DATA: string = "changeTournamentData";
    public static REGISTER_TOURNAMENT: string = "registerTournament";
    public static UNREGISTER_TOURNAMENT: string = "unregisterTournament";
    public static NEXT_TOURNAMENT_STARTTIME: string = "nextTournamentStarttime";
    public static CHANGE_NEXT_TOURNAMENT: string = "changeNextTournament";
    public static TOURNAMENT_END: string = "tournamentEnd";
    public static CHANGE_ZOMBIE: string = "changeZombie";
    public static TOURNAMENT_SETBLIND: string = "tournamentSetBlind";
    public static TOURNAMENT_TABLE_LIST: string = "tournamentTableList";
    public static TOURNAMENT_UPDATE_INFO: string = "tournamentUpdateInfo";
    public static BLUR_SELECTED_TABLE_LINE: string = "blurSelectedTableLine";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
